import request from './request'

export default {
  list(data) {
    return request.post('/floating/list', data)
  },
  info(data) {
    return request.post('/floating/info', data)
  },
  save(data) {
    return request.post('/floating/save', data)
  },
  enable(data) {
    return request.post('/floating/enable', data)
  },
  disable(data) {
    return request.post('/floating/disable', data)
  },
  delete(data) {
    return request.post('/floating/delete', data)
  },
}
